import { Component, input, Output, EventEmitter, computed } from '@angular/core';
import { ViewResponseModel } from '../../../CommonFiles/BusinessModels';

@Component({
  standalone: false,
  selector: 'app-view-item',
  templateUrl: 'view-item.component.html'
})
export class ViewItemComponent {
  view = input<ViewResponseModel>();
  active = input<ViewResponseModel>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onUpdate = new EventEmitter<void>();
  @Output() onSelect = new EventEmitter<void>();
  showConfirm: boolean = false;

  constructor() {  }

  toggleDialog():void {
    this.showConfirm = !this.showConfirm;
  }

  confirm():void {
    this.onDelete.emit();
    this.toggleDialog();
  }
  update() {
    this.onUpdate.emit();
  }

  select() {
    const active = this.active();
    const view = this.view();
    // ignore if same view
    if(view.name === active.name) { return; }
    this.onSelect.emit();
  }


}